import { BaseFormService } from "./base-form.service";
/**
 * keep in mind that every simple-fieldset and array-fieldset will auto-create an own instance of ModelFormService!
 */
export class ModelFormService extends BaseFormService {
  getDefaultValue() {
    if (this.modelFactory) return this.modelFactory.newInstance();else return {};
  }
  getInitialValue() {
    if (this.initialValue) {
      if (this.modelFactory) return this.modelFactory.fromData(this.initialValue);else return this.initialValue;
    } else if (this.modelFactory) {
      return this.modelFactory.newInstance();
    } else {
      return {};
    }
  }
  dataIsArray() {
    return false;
  }
}